import React from "react";
import PageStatus from "./PageStatus";
import { StatusCard, StatusTitle, StatusBody } from "components/ui/StatusCard";
import VisuallyHidden from "components/ui/VisuallyHidden";

import magnifyingGlass from "assets/images/glass_magnifying_200x175.jpg";
import { ModernBlueButtonLink } from "components/ui/ButtonLink";

export const NotFound404 = () => (
  <PageStatus data-testid="page-not-found-404">
    <VisuallyHidden>
      <h1>Page not found</h1>
    </VisuallyHidden>
    <StatusCard>
      <StatusTitle>
        <h2>Oops!</h2>
      </StatusTitle>
      <StatusBody>
        <img src={magnifyingGlass} style={{ float: `right` }} alt="" />
        <h3>Cannot Find That Page</h3>
        <p>
          For some reason CalCentral is unable to find the page you requested.
          To go to CalCentral, click the button below. To report a missing page,
          click the{" "}
          <a href="https://sis.berkeley.edu/help/report-issue">Feedback</a>{" "}
          link.
        </p>
        <ModernBlueButtonLink href="/dashboard" style={{ fontSize: `18px` }}>
          Go To Dashboard
        </ModernBlueButtonLink>
      </StatusBody>
    </StatusCard>
  </PageStatus>
);

export default NotFound404;
